// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"cb8d69a5","968":"d3415283"}[chunkId] + ".chunk.css";
};